// // Chakra Imports
// import {
//   Avatar,
//   Button,
//   Flex,
//   Icon,
//   Image,
//   Link,
//   Menu,
//   MenuButton,
//   MenuItem,
//   MenuList,
//   Text,
//   useColorModeValue,
//   Box,
// } from "@chakra-ui/react";
// // Custom Components
// import { ItemContent } from "components/menu/ItemContent";
// import { SearchBar } from "components/navbar/searchBar/SearchBar";
// // import { SidebarResponsive } from 'components/sidebar/Sidebar';
// import PropTypes from "prop-types";
// import React from "react";
// // Assets
// import navImage from "assets/img/layout/Navbar.png";
// import { ChevronDownIcon } from "@chakra-ui/icons";

// import { MdNotificationsNone, MdInfoOutline } from "react-icons/md";
// import { FaEthereum } from "react-icons/fa";
// import routes from "routes.js";
// import { ThemeEditor } from "./ThemeEditor";
// import { useNavigate } from "react-router-dom";
// import bigqueryImage from "assets/bigquery.svg";
// import { useLocation } from "react-router-dom";
// import { FaFileDownload } from "react-icons/fa";
// import {
//   setUploadFileModule_Data,
//   setUploadFileModule_Files,
//   setSelectedModules,
// } from "redux/slice/uploadFileModule";
// import { sendLogToServer } from "api/logging";
// import { supabase } from "supabase/supabaseClient";
// import { useDispatch } from "react-redux";
// import avatar11 from '../../assets/img/avatars/avatar11.png';

// import { FcUpload, FcAddDatabase } from "react-icons/fc";

// export default function HeaderLinks(props) {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { secondary, handleDownloadFileClick, handleBigQueryClick } = props;
//   // Chakra Color Mode
//   const navbarIcon = useColorModeValue("gray.400", "white");
//   let menuBg = useColorModeValue("white", "navy.800");
//   const textColor = useColorModeValue("secondaryGray.900", "white");
//   const textColorBrand = useColorModeValue("brand.700", "brand.400");
//   const ethColor = useColorModeValue("gray.700", "white");
//   const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
//   const ethBg = useColorModeValue("secondaryGray.300", "navy.900");
//   const ethBox = useColorModeValue("white", "navy.800");
//   const shadow = useColorModeValue(
//     "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
//     "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
//   );
//   const borderButton = useColorModeValue("secondaryGray.500", "whiteAlpha.200");

//   const handleLogout = async () => {
//     sendLogToServer("Logout");
//     await supabase.auth.signOut();
//     navigate("/");
//   };
//   return (
//     <Flex
//       w={{ sm: "100%", md: "auto" }}
//       alignItems="center"
//       flexDirection="row"
//       bg={menuBg}
//       flexWrap={secondary ? { base: "wrap", md: "nowrap" } : "unset"}
//       p="10px"
//       borderRadius="30px"
//       boxShadow={shadow}
//     >
//       {location.pathname === "/check-data" ||
//       location.pathname === "/report" ? (
//         <>
//           {/* <Box
//             cursor="pointer"
//             display="flex"
//             justifyContent="center"
//             alignItems="center"
//             width="120px"
//             height="40px"
//             backgroundColor="secondaryGray.300"
//             borderRadius="5%"
//             marginLeft="10px"
//             marginRight="6px"
//             onClick={handleBigQueryClick}
//           >
//             <Image src={bigqueryImage} height="95%" alt="BigQuery Logo" />
//           </Box> */}
//           <Button
//             bg="secondaryGray.300"
//             onClick={handleBigQueryClick}
//             leftIcon={<Icon as={FcAddDatabase} />}
//             mx={5}
//           >
//             Save Data
//           </Button>

//           <Box
//             cursor="pointer"
//             display="flex"
//             justifyContent="center"
//             alignItems="center"
//             width="120px"
//             height="40px"
//             backgroundColor="secondaryGray.300"
//             borderRadius="5%"
//             marginLeft="10px"
//             marginRight="15px"
//             paddingX="10px"
//             onClick={handleDownloadFileClick}
//           >
//             <Flex align="center">
//               <Icon
//                 w="24px"
//                 h="24px"
//                 me="5px"
//                 color="green.500"
//                 as={FaFileDownload}
//               />
//               <Text color={textColor} fontSize="sm" fontWeight="700">
//                 Download
//               </Text>
//             </Flex>
//           </Box>
//         </>
//       ) : (
//         <></>
//       )}
//       <Link href="#" passHref>
//         <Button
//           as="a"
//           backgroundColor="secondaryGray.300"
//           display="flex"
//           alignItems="center"
//           mx={5}
//           px={4}
//           py={2}
//           gap={3}
//         >
//           {/* Profile Image */}
//           <Box
//             as="img"
//             src={avatar11}
//             alt="S"
//             w="32px"
//             h="32px"
//             borderRadius="50%"
//             objectFit="cover"
//           />

//           {/* User Name */}
//           <Text
//             fontWeight="bold"
//             fontSize="md"
//             color="gray.800"
//             whiteSpace="nowrap"
//           >
//             Sara Jhonson
//           </Text>

//           {/* Dropdown Icon */}
//           <Icon as={ChevronDownIcon} w="20px" h="20px" color="gray.600" />
//         </Button>
//       </Link>

//       {/* <SearchBar
//         mb={secondary ? { base: "10px", md: "unset" } : "unset"}
//         me="10px"
//         borderRadius="30px"
//       /> */}
//       {/* <Flex
//         bg={ethBg}
//         display={secondary ? "flex" : "none"}
//         borderRadius="30px"
//         ms="auto"
//         p="6px"
//         align="center"
//         me="6px"
//       >
//         <Flex
//           align="center"
//           justify="center"
//           bg={ethBox}
//           h="29px"
//           w="29px"
//           borderRadius="30px"
//           me="7px"
//         >
//           <Icon color={ethColor} w="9px" h="14px" as={FaEthereum} />
//         </Flex>
//         <Text
//           w="max-content"
//           color={ethColor}
//           fontSize="sm"
//           fontWeight="700"
//           me="6px"
//         >
//           1,924
//           <Text as="span" display={{ base: "none", md: "unset" }}>
//             {" "}
//             ETH
//           </Text>
//         </Text>
//       </Flex> */}

//       <Menu>
//         <MenuButton p="0px">
//           <Avatar
//             _hover={{ cursor: "pointer" }}
//             color="white"
//             name="Adela Parkson"
//             bg="#11047A"
//             size="sm"
//             w="40px"
//             h="40px"
//           />
//         </MenuButton>
//         <MenuList
//           boxShadow={shadow}
//           p="0px"
//           mt="10px"
//           borderRadius="20px"
//           bg={menuBg}
//           border="none"
//         >
//           <Flex w="100%" mb="0px">
//             <Text
//               ps="20px"
//               pt="16px"
//               pb="10px"
//               w="100%"
//               borderBottom="1px solid"
//               borderColor={borderColor}
//               fontSize="sm"
//               fontWeight="700"
//               color={textColor}
//             >
//               👋&nbsp; Hey, Rahul
//             </Text>
//           </Flex>
//           <Flex flexDirection="column" p="10px">
//             <MenuItem
//               _hover={{ bg: "none" }}
//               _focus={{ bg: "none" }}
//               borderRadius="8px"
//               px="14px"
//             >
//               <Text fontSize="sm">Profile Settings</Text>
//             </MenuItem>
//             <MenuItem
//               _hover={{ bg: "none" }}
//               _focus={{ bg: "none" }}
//               borderRadius="8px"
//               px="14px"
//             >
//               <Text fontSize="sm">Newsletter Settings</Text>
//             </MenuItem>
//             <MenuItem
//               onClick={() => {
//                 navigate("/select-module-page");
//                 dispatch(setUploadFileModule_Data(null));
//                 dispatch(setSelectedModules("remove"));
//               }}
//               _hover={{ bg: "none" }}
//               _focus={{ bg: "none" }}
//               borderRadius="8px"
//               px="14px"
//             >
//               <Text fontSize="sm">Reset Settings</Text>
//             </MenuItem>
//             <MenuItem
//               _hover={{ bg: "none" }}
//               _focus={{ bg: "none" }}
//               color="red.400"
//               borderRadius="8px"
//               px="14px"
//               onClick={handleLogout}
//             >
//               <Text fontSize="sm">Log out</Text>
//             </MenuItem>
//             <Text fontSize="xs" color="grey" ml="15px">
//               Version 4.1
//             </Text>
//           </Flex>
//         </MenuList>
//       </Menu>
//     </Flex>
//   );
// }

// HeaderLinks.propTypes = {
//   variant: PropTypes.string,
//   fixed: PropTypes.bool,
//   secondary: PropTypes.bool,
//   onOpen: PropTypes.func,
// };

// Chakra Imports
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  Box,
} from "@chakra-ui/react";
// Custom Components
import { ItemContent } from "components/menu/ItemContent";
import { SearchBar } from "components/navbar/searchBar/SearchBar";
// import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from "prop-types";
import React from "react";
// Assets
import navImage from "assets/img/layout/Navbar.png";
import { ChevronDownIcon } from "@chakra-ui/icons";

import { MdNotificationsNone, MdInfoOutline } from "react-icons/md";
import { FaEthereum } from "react-icons/fa";
import routes from "routes.js";
import { ThemeEditor } from "./ThemeEditor";
import { useNavigate } from "react-router-dom";
import bigqueryImage from "assets/bigquery.svg";
import { useLocation } from "react-router-dom";
import { FaFileDownload } from "react-icons/fa";
import {
  setUploadFileModule_Data,
  setUploadFileModule_Files,
  setSelectedModules,
} from "redux/slice/uploadFileModule";
import { sendLogToServer } from "api/logging";
import { supabase } from "supabase/supabaseClient";
import { useDispatch } from "react-redux";
import avatar11 from "../../assets/img/avatars/avatar11.png";

import { FcUpload, FcAddDatabase } from "react-icons/fc";

export default function HeaderLinks(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { secondary, handleDownloadFileClick, handleBigQueryClick } = props;
  // Chakra Color Mode
  const navbarIcon = useColorModeValue("gray.400", "white");
  let menuBg = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.700", "brand.400");
  const ethColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const ethBg = useColorModeValue("secondaryGray.300", "navy.900");
  const ethBox = useColorModeValue("white", "navy.800");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  const borderButton = useColorModeValue("secondaryGray.500", "whiteAlpha.200");

  const handleLogout = async () => {
    sendLogToServer("Logout");
    try {
      await supabase.auth.signOut();
    } catch (e) {}
    try {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_email");
      localStorage.removeItem("user_id");
    } catch (e) {}
    navigate("/");
  };

  return (
    <Flex
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: "wrap", md: "nowrap" } : "unset"}
      p="10px"
      borderRadius="30px"
      boxShadow={shadow}
    >
      {location.pathname === "/check-data" ||
      location.pathname === "/report" ? (
        <>
          {/* <Box
            cursor="pointer"
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="120px"
            height="40px"
            backgroundColor="secondaryGray.300"
            borderRadius="5%"
            marginLeft="10px"
            marginRight="6px"
            onClick={handleBigQueryClick}
          >
            <Image src={bigqueryImage} height="95%" alt="BigQuery Logo" />
          </Box> */}
          {/* <Button
            bg="secondaryGray.300"
            onClick={handleBigQueryClick}
            leftIcon={<Icon as={FcAddDatabase} />}
            mx={5}
          >
            Save Data
          </Button>

          <Box
            cursor="pointer"
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="120px"
            height="40px"
            backgroundColor="secondaryGray.300"
            borderRadius="5%"
            marginLeft="10px"
            marginRight="15px"
            paddingX="10px"
            onClick={handleDownloadFileClick}
          >
            <Flex align="center">
              <Icon
                w="24px"
                h="24px"
                me="5px"
                color="green.500"
                as={FaFileDownload}
              />
              <Text color={textColor} fontSize="sm" fontWeight="700">
                Download
              </Text>
            </Flex>
          </Box> */}
        </>
      ) : (
        <></>
      )}

      {/* Dropdown Menu Button (updated to custom button) */}
      <Menu>
        <MenuButton
          as={Button}
          backgroundColor="secondaryGray.300"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="row"
          px={5}
          py={2}
          gap={2}
          height="40px"
          // width="120px"
          borderRadius="full"
          _hover={{ bg: "secondaryGray.400" }}
          _active={{ bg: "secondaryGray.500" }}
          sx={{
            "> *": { margin: 0 }, // Removes unwanted inner margins Chakra adds
          }}
        >
          {/* Profile Image */}
          <Box
            as="img"
            position="absolute"
            margin={"-6px"}
            src={avatar11}
            alt="Olivia Smith"
            w="32px"
            h="32px"
            borderRadius="full"
            objectFit="cover"
          />

          {/* User Name */}
          <Text
            fontWeight="bold"
            fontSize="md"
            paddingLeft="30px"
            color="gray.800"
            whiteSpace="nowrap"
          >
            Olivia Smith
          </Text>

          {/* Dropdown Icon */}
          {/* <Icon as={ChevronDownIcon} w="20px" h="20px" color="gray.600" /> */}
        </MenuButton>

        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              👋&nbsp; Hey, Olivia Smith
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              borderRadius="8px"
              px="14px"
            >
              <Text fontSize="sm">Profile Settings</Text>
            </MenuItem>
            <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              color="red.400"
              borderRadius="8px"
              px="14px"
              onClick={handleLogout}
            >
              <Text fontSize="sm">Log out</Text>
            </MenuItem>
            {/* <Text fontSize="xs" color="grey" ml="15px">
              Version 4.1
            </Text> */}
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
